import "./DadosSindicato.css";
import { formatCnpj } from "../../../../../utils";

const DadosSindicato = ({ DadosSindicato }) => {
  return (
    <div className="card shadow-sm p-4 mb-4 dados-sindicato">
      <h5 className="fw-bold text-uppercase border-bottom pb-2 mb-3">
        Dados do Sindicato
      </h5>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">CNPJ do Sindicato</label>
          <input
            type="text"
            className="form-control"
            value={formatCnpj(DadosSindicato?.cnpj || "")}
            readOnly
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">Nome do Sindicato</label>
          <input
            type="text"
            className="form-control"
            value={DadosSindicato?.nome || ""}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

export default DadosSindicato;
